module.exports = __webpack_public_path__ + "img/DSOAFFILIATES.9fe23709.jpg";